import setItemLocalStorageUtil from 'modules/local-storage/set-item/index.js'
import { PROFILE_LOCAL_STORAGE_KEY } from 'modules/profile/constants/index.js'

export function updateProfileFitnessDataModalShownAtAction (value) {
  return async (dispatch, getState) => {
    setItemLocalStorageUtil(
      PROFILE_LOCAL_STORAGE_KEY.PROFILE_FITNESS_DATA_MODAL_SHOWN_AT,
      value
    )
  }
}
